import { Button, ButtonProps } from '@eigtech/ui/components/button'
import { useDisclosure } from '@eigtech/ui/hooks/use-disclosure'
import { MediaCarouselProps } from './MediaCarousel'
import { MediaCarouselModal } from './MediaCarouselModal'

export type MediaCarouselButtonProps = Omit<ButtonProps, 'onClick'> & MediaCarouselProps

export function MediaCarouselButton({
  documents,
  getDocuments,
  initialDocument,
  ...props
}: MediaCarouselButtonProps) {
  const { onOpen, setOpen, open } = useDisclosure()

  return (
    <>
      <Button {...props} onClick={onOpen}>
        {props.children ?? 'View Media'}
      </Button>

      <MediaCarouselModal
        documents={documents}
        getDocuments={getDocuments}
        initialDocument={initialDocument}
        open={open}
        onOpenChange={setOpen}
      />
    </>
  )
}
